import {
  Component,
  inject,
  signal,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  YoutubeService,
  type YoutubeSearchResult,
} from '../../services/youtube.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { sampleSearchResultsWithDetails } from './search-samples';
import { LoadingComponent } from '../../components/loading/loading.component';
import { YoutubeThumbnailComponent } from '../../components/youtube-thumbnail/youtube-thumbnail.component';
import { PlaylistService } from '../../services/playlist.service';
import { NavigatorComponent } from '../../components/navigator/navigator.component';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { environment } from './../../../environments/environment';
import { UserService } from '../../services/user.service';


const HARDCODED_RESULTS: boolean = environment.production === false;
@Component({
  standalone: true,
  selector: 'app-youtube-search-enter',
  templateUrl: 'search.component.html',
  styleUrl: 'search.component.scss',
  imports: [
    FormsModule,
    CommonModule,
    LoadingComponent,
    YoutubeThumbnailComponent,
    NavigatorComponent,
    ButtonModule,
    FloatLabelModule,
    InputTextModule,
  ],
})
export class SearchComponent {
  hardcodedResults = HARDCODED_RESULTS;
  dummyResults = signal(sampleSearchResultsWithDetails);
  query = '';
  youtube = inject(YoutubeService);
  playlistService = inject(PlaylistService);
  userService = inject(UserService);
  hasSearched = signal(false);
  results = this.youtube.results;

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  onEnter() {
    this.hasSearched.set(true);
    this.youtube.search(this.query, true);
  }

  addToPlaylist(result: YoutubeSearchResult) {
    if (confirm(`Lisa "${result.title}" järjekorda?`)) {
      const userId = this.userService.getCurrentUserId();
      if (userId === null) {
        console.error('❌ Cannot add video: no registered user found.');
        return;
      }

      const video = {
        userId,
        playlistId: 1,
        ...result,
      };
      this.playlistService.addVideoToPlaylist(video);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    });
  }
}
